define('viewModels/privileged/qm/policies/editors/DurationRangeEditorView',[
    'lib/lodash4',
    'lib/knockout',
    'jquery',
    'viewModels/ViewModel',

    // No references
    'extensions/i18n/knockout.i18n',
    'extensions/knockout.validation.extender',
    'lib/knockout.validation'
], function (_, ko, $, ViewModel) {
    'use strict';
    var DurationRangeEditorView = ViewModel.extend(function (durationObservable) {
        var self = this;
        if (!ko.isObservable(durationObservable)) {
            throw "durationObservable must be an observable!";
        }

        var DURATION_TARGET = 'DURATION_RANGE';
        var duration = durationObservable;
        self.durationMode = ko.observable();
        self.durationStart = ko.observable(0).extend({ isDurationGreater: self.durationEnd, isDurationNotEqual: self.durationEnd });
        self.durationEnd = ko.observable(0).extend({ isDurationLess: self.durationStart, isDurationNotEqual: self.durationStart });

        var convertSavedDurations =  function(durationRange) {
            var rangeValues = durationRange.split('/');
            self.durationStart( parseInt(rangeValues[0]) );
            self.durationEnd( parseInt(rangeValues[1]) );
        };

        if (duration() && duration().hasOwnProperty('durationRange')) {
            convertSavedDurations(ko.unwrap(duration().durationRange));
        }
        if(duration() && duration().hasOwnProperty('durationMode')){
            self.durationMode(ko.unwrap(duration().durationMode).toUpperCase());
        }

        var updateDurationValue = function (start, end, durationMode) {
            if (_.isUndefined(start)) {
                start = 0;
            }
            if (_.isUndefined(end)) {
                end = 0;
            }
            if(_.isUndefined(durationMode)){
                durationMode= null;
            }

            var durationRange = start + '/' + end;

            duration({durationTarget: DURATION_TARGET, durationRange: durationRange, durationMode: durationMode});
        };

        self.computed(function () {
            updateDurationValue(self.durationStart(), self.durationEnd(), self.durationMode());
        });

    });

    return DurationRangeEditorView;
});

